module.exports = __webpack_public_path__ + "static/media/27OCHA8.06e836c9.jpg";